import { getUrlWithVariant, ProductForm } from '@shopify/theme-product-form';
import { formatMoney } from '@shopify/theme-currency';
import Swiper from "swiper";
import { addItem, getCart } from "Scripts/cartAjaxCall";
import { register } from '@shopify/theme-sections';

register('product', {
  _initProduct(handle) {
    if (handle) {
      window.Product = new Product(this.container);
    } else {
    }
  },
  
  // Shortcut function called when a section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
  onLoad: function(e) {
    this._initProduct(this.container.dataset.handle);
    // Do something when a section instance is loaded
  },
  
  // Shortcut function called when a section unloaded by the Theme Editor 'shopify:section:unload' event.
  onUnload: function() {
    // Do something when a section instance is unloaded
  }
});


export class Product {
  constructor(elem) {
    this.wrapper = $(elem);
    this.handle = this.wrapper.data('handle');
    this.formElement = this.wrapper.find('[data-product-form]');
    this.submitButton = this.wrapper.find('[data-submit-button]');
    this.submitButtonText = this.wrapper.find('[data-submit-button]');
    this.priceContainer = this.wrapper.find('[data-price-wrapper]');
    this.shopifyButtons = this.wrapper.find('[data-shopify="payment-button"]');
    this.optionSizeTitle = this.wrapper.find('.variant-metafield');
    this.initSizeTitleMetafield();
    this.initProductGallery();
    this.getProduct()
      .then(product => {
        this.product = product;
        this.form = new ProductForm(this.formElement[0], this.product, {
          onOptionChange: this.onOptionChange.bind(this),
          onFormSubmit: this.initAddToBag.bind(this)
        });
        if (this.optionSizeTitle.length != 0) {
          this.initOptionSizeTitle();
        }
        this.initVariantPricing(product);
        this.initSelectedVariant();
        this.inputsTriggerSelect();
      });

      window.UploadKit = window.UploadKit || {}
      window.UploadKit.callbacks = window.UploadKit.callbacks || {}
      window.UploadKit.callbacks.afterRefresh = (data) => {
        this.handleUploadkitCallback(data);
      }
  }

  initSizeTitleMetafield() {
    this.optionSizeTitleMetafields = document.getElementById('variantMetafields');
    if (this.optionSizeTitleMetafields) {
      this.metafields = JSON.parse(this.optionSizeTitleMetafields.innerHTML).data;
    }
  }
  
  initProductGallery() {
    var productGalleryThumbs  = new Swiper('.product-gallery-thumbs', {
      spaceBetween: 11,
      direction: 'vertical',
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      speed: 800,
      watchOverflow: true,
    });
    var productGallery  = new Swiper('.product-gallery', {
      slidesPerView: 1.25,
      spaceBetween: 12,
      speed: 800,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1200: {
          slidesPerView: 1,
          spaceBetween: 110,
        },
      },
      thumbs: {
        swiper: productGalleryThumbs
      },
    });
  }

  initVariantPricing(product) {
    for (let variant of product.variants) {
      if (this.form.variant().option2 == variant.option2) {
        let currentOption = variant.option1.replaceAll('"', ''),
        price = document.querySelector(`[data-variant-price="${currentOption}"]`);
        price.innerHTML = `${ formatMoney(variant.price, theme.moneyFormat) }`;
        // price.append(`<del>${ formatMoney(variant.compare_at_price, theme.moneyFormat) }</del>`);
      }
    }
  }

  handleUploadkitCallback(data) {
    const elements =['.product-gallery-thumbs__img picture', '.product-gallery__img picture'];
    
    elements.forEach(element => {
      const pictureElement = document.querySelector(element);
      const sources = [...pictureElement.querySelectorAll('source')];
      
      sources.forEach(source => {
        source.remove();
      });

      if (data.files && data.files.length > 0) {
        // If upload File does exist
        const mainImage = data.files[0].fileInfo.cdnUrl;
        pictureElement.querySelector('img').src = mainImage;
        pictureElement.classList.add('uploaded-image');
      } else {
        const originalImage = pictureElement.querySelector('img').dataset.src;
        pictureElement.querySelector('img').src = originalImage;
        pictureElement.classList.remove('uploaded-image');
      }
    });
  }
  
  updateVariantUrl(variant) {
    if (!variant) return;
    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({path: url}, '', url);
  }
  
  onOptionChange(event) {
    const variant = event.dataset.variant;
    this.slideToVariantImage(variant);
    this.updateVariantPrice(variant);
    this.updateSubmitButton(variant);
    this.updateVariantUrl(variant);
    this.updateOptionSizeTitle(variant);
    this.initVariantPricing(this.product)
  }
  
  async getProduct() {
    const response = await fetch(`/products/${ this.handle }.js`);
    return await response.json();
  }
  
  updateSubmitButton(variant) {
    if (!variant) {
      this.submitButton.addClass('disabled').attr('disabled', 'disabled');
      this.submitButtonText.text(theme.strings.unavailable);
      this.shopifyButtons.addClass('d-none');
    } else if (variant.available) {
      this.submitButton.removeClass('disabled').removeAttr('disabled');
      this.submitButtonText.text(theme.strings.addToCart);
      this.shopifyButtons.removeClass('d-none');
    } else {
      this.submitButtonText.text(theme.strings.soldOut);
      this.submitButton.addClass('disabled').attr('disabled', 'disabled');
      this.shopifyButtons.addClass('d-none');
    }
  }
  
  updateVariantPrice(variant) {
    this.priceContainer.empty();
    if (variant) {
      if (variant.compare_at_price > variant.price) {
        this.priceContainer.append(`<ins>${ formatMoney(variant.price, theme.moneyFormat) }</ins>`);
        this.priceContainer.append(`<del>${ formatMoney(variant.compare_at_price, theme.moneyFormat) }</del>`);
      } else {
        this.priceContainer.append(`${ formatMoney(variant.price, theme.moneyFormat) }`);
      }
    }
  }
  
  updateOptionTitle(wrapper, text) {
    wrapper.innerHTML = text;
  }
  
  slideToVariantImage(variant) {
    if (variant) {
      const imageLabel = variant.featured_media ? variant.featured_media.preview_image.src : '';
      const imagePosition = variant.featured_media ? variant.featured_media.position - 1 : '';
      // this.productGallery.slideTo(imagePosition);
    }
  }
  
  initSelectedVariant() {
    const currentIndex = this.form.variant().featured_media ? this.form.variant().featured_media.position - 1 : 0;
  }
  
  initAddToBag(event) {
    event.preventDefault();
    addItem(this.form.element)
      .then((item) => {
        getCart().then((cart) => {
          const {item_count, items} = cart;
          CartStore.setState({cart, item_count, items, justAdded: item});
          CartStore.actions.openMinicart();
        })
      });
  }
  
  //Inputs trigger select
  inputsTriggerSelect() {
    let wrapper = document.querySelector('section[data-section-type="product"]');
    let inputs = wrapper.querySelectorAll('.js-custom-input input');
    if (!wrapper) return false;
    
    
    const triggerSelect = (e) => {
      let optionPosition = e.target.dataset.optionPosition;
      let inputs = wrapper.querySelectorAll(`input[data-option-position="${optionPosition}"]`);
      let inputValue = e.target.dataset.title;
      let currentSelect = wrapper.querySelector(`#Option${optionPosition}`);
      let currentOptionTitleHTML = wrapper.querySelector(`[data-option-position="${optionPosition}"]`);
      
      for (let input of inputs) {
        if (input.name == "Size") { continue };
        if (input.dataset.title === inputValue) {
          input.setAttribute('checked', 'checked');
          this.updateOptionTitle(currentOptionTitleHTML, inputValue);
        } else {
          input.removeAttribute('checked');
        }
      }
      
      currentSelect.value = inputValue;
      currentSelect.dispatchEvent(new Event('change'));
    }
    
    inputs.forEach((input, i) => {
      input.addEventListener('change', triggerSelect);
    });
  }
  
  //Init option size title
  initOptionSizeTitle() {
    this.metafields.forEach((metafield) => {
      if (this.form.variant().id == metafield.variant_id) {
        this.optionSizeTitle.text(metafield.metafields.details);
      }
    })
  }
  
  //Update  option size title
  updateOptionSizeTitle(variant) {
    if (!variant) return;
    this.initOptionSizeTitle();
  }
}

